import React from 'react'

const DefaultsContext = React.createContext()

export default DefaultsContext
